export interface GenderTimeData {
  year: string
  male: number
  female: number
}

export interface ParticipantDemographicsData {
  buyersCount: number
  sellersCount: number
  personsCount: number
  companiesCount: number
  buyersGender: {
    male: number
    female: number
  }
  sellersGender: {
    male: number
    female: number
  }
  participantTypesByLegalForm: Array<{
    type: string
    count: number
  }>
  genderOverTime: GenderTimeData[]
}

export interface ParticipantDemographicsChartLabels {
  totalBuyers?: string
  totalSellers?: string
  individualParticipants?: string
  companyParticipants?: string
  buyersByGender?: string
  sellersByGender?: string
  personVsCompany?: string
  female?: string
  male?: string
  individuals?: string
  companies?: string
  genderDistributionOverTime?: string
  genderParity?: string
  participantTypesByLegalForm?: string
  noData?: string
}

export const DEFAULT_PARTICIPANT_DEMOGRAPHICS_CHART_LABELS: ParticipantDemographicsChartLabels =
  {
    totalBuyers: 'Total Buyers',
    totalSellers: 'Total Sellers',
    individualParticipants: 'Individual Participants',
    companyParticipants: 'Company Participants',
    buyersByGender: 'Buyers by Gender',
    sellersByGender: 'Sellers by Gender',
    personVsCompany: 'Person vs Company Participants',
    female: 'Female',
    male: 'Male',
    individuals: 'Individuals',
    companies: 'Companies',
    genderDistributionOverTime: 'Buyers Gender Distribution Over Time',
    genderParity: '50% Gender Parity',
    participantTypesByLegalForm: 'Participant Types by Legal Form',
    noData: 'No data available',
  }

export interface ParticipantDemographicsChartProps {
  data: ParticipantDemographicsData | null
  loading?: boolean
  error?: string | null
  labels?: Partial<ParticipantDemographicsChartLabels>
}
